/// <reference path="../_references.ts"/>

module App.TemplateStore {
	import TitleBarService = App.Helpers.TitleBarService;
	import BannerService = App.WorkOrder.BannerService;

	export class TemplateStoreController {

		searchText: string = '';
		filterFavorites: boolean = false;
		showSection: TemplateType = 'Global';

		//TODO Get from organization
		tokenCount: number = 0;

		fullTemplateList: StoreTemplate[];
		displayedTemplateList: StoreTemplate[];
		selectedTemplateId: number;
		public: boolean = true;

		pageSize: number = 25;
		page: number = 1;
		count: number = 0;
		maxPage: number = 1;

		static $inject = ['$state', 'TemplateStoreService', 'TitleBarService', 'BannerService'];
		constructor(
			private $state: ng.ui.IStateService,
			private TemplateStoreService: TemplateStoreService,
			private TitleBarService: TitleBarService,
			private BannerService: BannerService
		) {
			const vm = this;

			TitleBarService.set('Rachel\'s Place', 'pinkText');
			vm.getTemplatesList();
		}

		getTemplatesList() {
			this.TemplateStoreService.getTemplateList({
				query: this.searchText,
				page: this.page,
				size: this.pageSize,
				public: this.public ? 1 : 0
			}).then((response) => {
				let headers = response.headers();

				if (this.updatePageInfo(Number(headers.count))) {
					this.page = this.maxPage;
					return this.getTemplatesList();
				}

				this.fullTemplateList = response.data.map((template) => { return new StoreTemplate(template)});
				this.filterTemplates();
			});
		}

		setPage(page: number) {
			let newPage = Math.max(1, Math.min(this.maxPage, page));
			if (newPage !== this.page) {
				this.page = newPage;
				this.getTemplatesList();
			}
		}

		getItemCount() {
			if (this.count === 0) {
				return '0 - 0 of 0';
			}

			return Math.min(this.count, ((this.page - 1) * this.pageSize) + 1) + ' - ' + Math.min(this.count, this.pageSize * this.page) + ' of ' + this.count;
		}

		updatePageInfo(count: number) {
			this.count = count;
			this.maxPage = Math.max(1, Math.ceil(this.count / this.pageSize));

			return this.maxPage < this.page;
		}

		toggleFavorites() {
			const vm = this;

			this.filterFavorites = !this.filterFavorites;
			vm.filterTemplates();
		}

		toggleTemplateFavorite(template: StoreTemplate) {
			const vm = this;

			template.favorited = !template.favorited;

			if(template.favorited) {
				vm.TemplateStoreService.favoriteTemplate(template.id);
			} else {
				vm.TemplateStoreService.unfavoriteTemplate(template.id);
			}

			vm.filterTemplates();
		}

		toggleSection(sectionName: TemplateType) {
			const vm = this;

			if(sectionName == 'Proprietary') {
				alert('You do not have access to any Proprietary templates');
				return;
			}

			this.showSection = sectionName;
			this.public = !this.public;
			vm.getTemplatesList();
		}

		filterTemplates() {
			const vm = this;

			vm.displayedTemplateList = vm.fullTemplateList.filter((template) => {
				let favoriteFilter = true;
				if(vm.filterFavorites) {
					favoriteFilter = template.favorited;
				}
				return favoriteFilter;
			});
		}

		selectTemplate(id: number) {
			this.selectedTemplateId = id;
		}

		viewTemplate() {
			if (!this.selectedTemplateId) {
				alert('You must select a template to view');
				return;
			}
			this.$state.go('zipSolutions.template-store.details', { id: this.selectedTemplateId });
		}

		isSelected(sectionName: TemplateType) {
			const vm = this;

			if(vm.showSection === sectionName) {
				return true;
			}
		}
	}
}